import React, { useState, useEffect } from "react";
import { auth } from "../firebaseConfig";
import Fade from "react-reveal/Fade";

import "../styles/GenerationPage.css";
import { useNavigate } from "react-router-dom";
import imageLarge from "../assets/Rectangle 9.png";
import imageSmall1 from "../assets/Rectangle 10.png";
import imageSmall2 from "../assets/Rectangle 11.png";
import imageBottom from "../assets/Rectangle 12.png";
import icon from "../assets/rightArrow.png";

const GenerationPage = () => {
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState("");
  const [User, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        console.log("No user logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  const goToNewPage = () => {
    if (User) {
      navigate("/process", { state: { prompt } });
    } else {
      navigate("/signin");
    }
    console.log(prompt);
  };

  return (
    <div className="content-section">
      <h2 className="section-heading">Best AI Content Platform</h2>
      <h3 className="gradient-heading">Image Generate</h3>
      <p className="section-paragraph">
        Your One-Stop Solution for Content Creation, Audio Generation, <br />
        Image Crafting, & AI Chatbot Development.
      </p>

      <div className="input-container">
        <input
          type="text"
          className="text-input"
          placeholder="Enter Prompt..."
          onChange={(e) => {
            setPrompt(e.target.value);
          }}
          value={prompt}
        />

        <button className="generate-button" onClick={goToNewPage}>
          Generate
        </button>
      </div>

      <div className="tags-container">
        <span className="tags-heading">Popular Tags: </span>
        <button className="tag-button">Creative</button>
        <button className="tag-button">Fantasy</button>
        <button className="tag-button">Sport</button>
        <button className="tag-button">Animation</button>
      </div>

      <div className="image-section">
        <div className="image-left">
          <Fade bottom>
            <img src={imageLarge} alt="Large Visual" className="large-image" />
          </Fade>
          <p className="image-description">
            We're passionate about empowering creatives with the tools they need
            to bring their vision to life, that's why we've developed.
          </p>
          <button className="generate-button-with-icon" onClick={goToNewPage}>
            <img src={icon} alt="Icon" className="button-icon" />
            Generate
          </button>
        </div>
        <div className="image-right">
          <div className="top-images">
            <Fade bottom>
              <img
                src={imageSmall1}
                alt="Small Visual 1"
                className="small-image"
              />
            </Fade>
            <Fade bottom>
              <img
                src={imageSmall2}
                alt="Small Visual 2"
                className="small-image"
              />
            </Fade>
          </div>
          <Fade bottom>
            <img
              src={imageBottom}
              alt="Bottom Visual"
              className="bottom-image"
            />
          </Fade>
        </div>
      </div>

      <h4 className="highlighted-heading">
        Provide Description,
        <span className="highlight"> Get Instant AI Generated Content </span>
      </h4>

      <div className="rectangle-buttons-container">
        <div className="rectangle-buttons-row">
          <button className="rectangle-button">Image To Painting</button>
          <button className="rectangle-button">Background Removal</button>
          <button className="rectangle-button">Sketch to Image</button>
          <button className="rectangle-button">Recolor Images</button>
          <button className="rectangle-button">Anime Generator</button>
          <button className="rectangle-button">Up-Scale Image</button>
          <button className="rectangle-button">Photo to Anime</button>
          <button className="rectangle-button">Logo Generator</button>
          <button className="rectangle-button">Up-Scale Image</button>
          <button className="rectangle-button">Background Removal</button>
          <button className="rectangle-button">Recolor Images</button>
          <button className="rectangle-button">Background Removal</button>
          <button className="rectangle-button">Anime Generatorl</button>
          <button className="rectangle-button">Sketch to Image</button>
          <button className="rectangle-button">Image To Painting</button>
          <button className="rectangle-button">Background Removal</button>
        </div>
        <div className="rectangle-buttons-row">
          <button className="rectangle-button">Image To Painting</button>
          <button className="rectangle-button">Background Removal</button>
          <button className="rectangle-button">Sketch to Image</button>
          <button className="rectangle-button">Recolor Images</button>
          <button className="rectangle-button">Anime Generator</button>
          <button className="rectangle-button">Up-Scale Image</button>
          <button className="rectangle-button">Photo to Anime</button>
          <button className="rectangle-button">Logo Generator</button>
          <button className="rectangle-button">Up-Scale Image</button>
          <button className="rectangle-button">Background Removal</button>
          <button className="rectangle-button">Recolor Images</button>
          <button className="rectangle-button">Background Removal</button>
          <button className="rectangle-button">Anime Generatorl</button>
          <button className="rectangle-button">Sketch to Image</button>
          <button className="rectangle-button">Image To Painting</button>
          <button className="rectangle-button">Background Removal</button>
        </div>
      </div>
    </div>
  );
};

export default GenerationPage;
